import * as React from 'react'
import { GlobalModalsManager } from './GlobalModalsManager'

export const GlobalModalsContext = React.createContext<{
  modalManager: GlobalModalsManager
}>({
  modalManager: new GlobalModalsManager()
})
